import MainLayout from "@/components/layout/applicant/MainLayout.vue";
import RegionJson from "@/assets/json/region.json";
import axios from "axios";
import { updatePageSeo, injectJobPostingSchema, removeJobPostingSchema, injectBreadcrumbSchema, removeBreadcrumbSchema } from "@/utils/seo";

export default {
    name: "jobListingJobDetail",
    components: {
        MainLayout
    },

    data() {
        return {
            jobInfo: {
                id: "",
                path: "",
                company_name: "",
                job_title: "",
                job_type: "",
                region: "",
                town: "",
                address: "",
                min_salary: "",
                max_salary: "",
                category_name: "",
                description: "",
                gender: "",
                experience: "",
                qualification: "",
                expired_date: "",
                posted_date: "",
            },
            regionArr: RegionJson,
            similarJobs: []
        };
    },

    watch: {
        '$route.params.id'(newId) {
            if (newId) {
                this.getJobDetail();
                window.scrollTo(0, 0);
            }
        }
    },

    methods: {
        getJobDetail() {
            axios.get("/job/detail/" + this.$route.params.id)
                .then(response => {
                    if (!response.data || !response.data.id || response.data.is_expired) {
                        this.$router.push({ name: "notFound" });
                        return;
                    }
                    this.jobInfo = response.data;

                    const cleanDesc = (this.jobInfo.short_desc || this.jobInfo.description || '')
                        .replace(/<[^>]*>?/gm, '')
                        .trim()
                        .slice(0, 160);

                    const regionName = (this.regionArr && this.regionArr[this.jobInfo.region]) ? this.regionArr[this.jobInfo.region] : (this.jobInfo.region || '');
                    const locationText = regionName ? ` (${regionName})` : '';
                    const pageTitle = `${this.jobInfo.job_title} - ${this.jobInfo.company_name}${locationText}`;

                    updatePageSeo({
                        title: pageTitle,
                        description: cleanDesc || `${this.jobInfo.job_title} အလုပ်အကိုင် အသေးစိတ် ရယူလျှောက်ထားပါ။`,
                        image: this.jobInfo.company_logo_path,
                        url: window.location.href,
                        type: 'article'
                    });

                    injectJobPostingSchema({
                        ...this.jobInfo,
                        region_name: regionName
                    });
                    injectBreadcrumbSchema([
                        { name: "ပင်မစာမျက်နှာ", url: "https://bib-job.com/" },
                        { name: "အလုပ်အကိုင်များ", url: "https://bib-job.com/job_listing/index/0" },
                        { name: `${this.jobInfo.job_title} at ${this.jobInfo.company_name}`, url: window.location.href }
                    ]);

                    if (response.data.category_id) {
                        this.getSimilarJobs(response.data.category_id, response.data.id);
                    }
                })
                .catch(error => {
                    console.log("Job Detail API Error", error);
                    this.$router.push({ name: "notFound" });
                });
        },
        getSimilarJobs(categoryId, currentJobId) {
            axios.get("/applicant/search/jobresult", {
                params: {
                    keyword1: categoryId,
                    per_page: 7
                }
            })
                .then(response => {
                    const jobs = (response.data && response.data.data) ? response.data.data : [];
                    this.similarJobs = jobs.filter(j => j.id != currentJobId).slice(0, 6);
                })
                .catch(error => {
                    console.log("Similar Jobs API Error", error);
                });
        },
        getJobType(job_type) {
            if (job_type == '1') {
              this.job_type = 'Full-time';
            } else if (job_type == '2') {
              this.job_type = 'Part-time';
            } else if (job_type == '3') {
              this.job_type = 'Internship';
            } else if (job_type == '4') {
              this.job_type = 'Freelance';
            } else if (job_type == '5') {
              this.job_type = 'Remote Job';
            } else {
              this.job_type = 'သတ်မှတ်ထားခြင်းမရှိပါ';
            }
            return this.job_type;
          },
        goFB(id) {
            window.open("https://www.facebook.com/sharer/sharer.php?u=https://bib-job.com/job_listing/job_detail/" + id + "&t=" + document.title, '',
            'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=500');
        },

        formatNumber(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },

    },

    mounted() {
        this.getJobDetail();
    },

    beforeDestroy() {
        removeJobPostingSchema();
        removeBreadcrumbSchema();
    }
};
